import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
  BaseTablesRequest,
  BaseTableValuesRequest,
  BaseTableValueCreateRequest,
  BaseTableValueDeleteRequest,
  BaseTablesResponse,
  BaseTableValuesResponse,
  BaseTableValueCreateResponse,
  BaseTableValueDeleteResponse
} from '../../models/BaseTable.model';
import { environment } from '../../environments';

const API_BASE_URL = environment.apiUrl;

// קבלת כותרות טבלאות בסיס
export const getBaseTables = createAsyncThunk<
  BaseTablesResponse,
  BaseTablesRequest,
  { rejectValue: string }
>(
  'baseTables/getTables',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}BaseTable/GetBaseTables`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: BaseTablesResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to fetch base tables');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

// קבלת ערכים לטבלה ספציפית
export const getBaseTableValues = createAsyncThunk<
  BaseTableValuesResponse,
  BaseTableValuesRequest,
  { rejectValue: string }
>(
  'baseTables/getTableValues',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}BaseTable/GetTableValues`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: BaseTableValuesResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to fetch table values');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

// יצירת/עדכון ערך
export const createBaseTableValue = createAsyncThunk<
  BaseTableValueCreateResponse,
  BaseTableValueCreateRequest,
  { rejectValue: string }
>(
  'baseTables/createValue',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}BaseTable/CreateOrUpdateValue`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: BaseTableValueCreateResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to create/update value');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

// עדכון ערך (אותו thunk כמו create)
export const updateBaseTableValue = createBaseTableValue;

// מחיקת ערך
export const deleteBaseTableValue = createAsyncThunk<
  BaseTableValueDeleteResponse,
  BaseTableValueDeleteRequest,
  { rejectValue: string }
>(
  'baseTables/deleteValue',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}BaseTable/DeleteValue`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: BaseTableValueDeleteResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to delete value');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);